import { ObsessedEngineeringEmailSubscription } from '../enums/obsessed-engineering-email-subscription.enum';

export interface ObsessedEngineeringStringLabelConfig {
    labelText: string;
    rowsPerLabel: number;
}

export interface ObsessedEngineeringEmailContact {
    name: string;
    email: string;
    subscriptions: ObsessedEngineeringEmailSubscription[];
}

export interface ObsessedEngineeringData {
    smallLabelPrinterId: string;
    largeLabelPrinterId: string;
    oeAddressInfo: string;
    stringLabelConfigs: ObsessedEngineeringStringLabelConfig[];
    emailContacts: ObsessedEngineeringEmailContact[];
}

export const DEFAULT_OBSESSED_ENGINEERING_STRING_LABEL_CONFIG: ObsessedEngineeringStringLabelConfig = {
    labelText: '',
    rowsPerLabel: 1,
};

export const DEFAULT_OBSESSED_ENGINEERING_ADDRESS_INFO = 'Obsessed Engineering\n455 Rolling Acres Rd\nLady Lake, FL 32159-5030';
export const SELJAN_INVOICE_ADDRESS_INFO = 'Seljan Company Inc.\nP.O. Box 158\nLake Mills, WI 53551';

export const DEFAULT_OBSESSED_ENGINEERING_DATA: ObsessedEngineeringData = {
    smallLabelPrinterId: '',
    largeLabelPrinterId: '',
    oeAddressInfo: DEFAULT_OBSESSED_ENGINEERING_ADDRESS_INFO,
    stringLabelConfigs: [],
    emailContacts: [],
};
